"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@angular/core");
const core_2 = require("@ngx-translate/core");
const FourDInjector_1 = require("../../../FourDInjector");
const buckets_component_1 = require("../buckets.component");
class BucketComponent {
    constructor(_parent) {
        this._parent = _parent;
        this.debug = false;
        this.plugin = null;
        this.index = 0;
        this.showMe = false;
        this.translate = null;
        // items:any = [];
        this.controller = null;
        this.textual = null;
        this.id = this.uuidv4();
        // parent buckets controller
        this.buckets = null;
        this.timePasses = 0;
        this.buckets = _parent;
        this.translate = FourDInjector_1.FourDInjector.injector.get(core_2.TranslateService);
    }
    uuidv4(token = '_', prefix = 'uuid_') {
        return (prefix + 'xxxxxxxx' + token + 'xxxx' + token + '4xxx' + token + 'yxxx' + token + 'xxxxxxxxxxxx').replace(/[xy]/g, function (c) {
            var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }
    myIndex() {
        /* this.timePasses--;
        if ( this.timePasses > 0 ) {
          return this.index;
        }
        this.timePasses = 50; */
        let idx = 0;
        let token = this.controller.id;
        if (this.controller && this.buckets) {
            if (this.controller.selectedItem) {
                this.buckets.isActive(token);
            }
            else {
                this.buckets.isInactive(token);
            }
            idx = this.buckets.getMyIndex(token);
        }
        this.index = idx;
        return idx;
    }
    myRight() {
        return (30 + (this.index * 400)) + 'px';
    }
    ngOnInit() {
        if (this.plugin) {
            this.plugin.registerComponent(this);
            if (this.plugin.config && this.plugin.config.languageToken) {
                this.textual = 'PLUGINS.BUCKET.' + this.plugin.config.languageToken + '.';
            }
            if (this.plugin.config && this.plugin.config.controller) {
                this.controller = this.plugin.config.controller;
            }
        }
        if (this.debug) {
            console.log('BUCKET comp INIT', this.textual, this.plugin, this.controller);
        }
    }
}
exports.BucketComponent = BucketComponent;
